import { handleDataTracker } from './tracker';

const BookYourSeatButtonV2 = ({
  data,
  setShowBookYouSeatPopUp,
  sectionName,
  setFormClickedSection,
  ctaPriceText,
  programName
}: {
  data: any;
  setShowBookYouSeatPopUp: any;
  sectionName: string;
  setFormClickedSection: any;
  ctaPriceText: string;
  programName?: string;
}) => {
  return (
    <>
      {data?.ctaTargetLink && (
        <div className="primaryBtn-wrap flex">
          <a
            href={data?.ctaTargetLink}
            target="_blank"
            rel="noopener noreferrer"
            data-tracker-id={sectionName}
            className="target-link-ele primary-btn relative bg-[#DB4144] md:h-[68px] h-[72px] md:w-[370px] w-full text-white text-center md:rounded-[2px] rounded md:px-[20px] px-4 "
          >
            <div className="absolute top-1/2 w-full -translate-y-1/2 left-1/2 -translate-x-1/2">
              <div className="flex items-center justify-center">
                <div className="PrimarybuttonIcon bg-spriteImg md:h-6 h-[14px] transform-none md:scale-[0.666] md:w-6 w-[14px]" />
                <span className="md:text-[21px] md:leading-[25px] text-base leading-5 font-bold md:ml-4 ml-2 ">
                  {data.ctaText}
                </span>
              </div>
              {ctaPriceText && (
                <p
                  className="pt-[6px] md:pt-[7px]  md:text-[11px] text-xs md:font-medium font-regular md:leading-[13px] leading-[16px]"
                  dangerouslySetInnerHTML={{ __html: `(${ctaPriceText})` }}
                />
              )}
            </div>
          </a>
        </div>
      )}
      {!data?.ctaTargetLink && data?.ctaText && (
        <div className="primaryBtn-wrap flex">
          <button
            onClick={() => {
              setShowBookYouSeatPopUp(true);
              handleDataTracker(sectionName, '', programName);
              setFormClickedSection(sectionName);
            }}
            data-bs-target="#staticBackdrop1"
            data-bs-toggle="modal"
            className="primary-btn bg-[#DB4144] md:h-[68px] h-[72px] md:w-[370px] w-full text-white text-center md:rounded-[2px] rounded md:px-[20px] px-4 "
          >
            <div className="flex items-center justify-center">
              <div className="PrimarybuttonIcon bg-spriteImg md:h-6 h-[14px] transform-none md:scale-[0.666] md:w-6 w-[14px]" />
              <span className="md:text-[21px] md:leading-[25px] text-base leading-5 font-bold md:ml-4 ml-2">
                {data.ctaText}
              </span>
            </div>
            {ctaPriceText && (
              <p
                className="pt-[6px] md:pt-[7px]  md:text-[11px] text-xs md:font-medium font-regular md:leading-[13px] leading-[16px]"
                dangerouslySetInnerHTML={{ __html: `(${ctaPriceText})` }}
              />
            )}
          </button>
        </div>
      )}
    </>
  );
};

export default BookYourSeatButtonV2;
